<template>
  <div
    class="py-2 px-3 bg-yellow-very-light w-full flex items-center relative"
  >
    <AppInput
      v-model="search"
      border-color="border-color-disabled"
      :placeholder="$t('filter.input')"
      size="sm"
      :is-hidden-error="true"
      class="w-full"
      :loading="isLoading"
      @input="isTyping = true"
      @focus="showList"
    >
      <template #icon-left>
        <AppIcon
          name="magnify"
          class="ml-2"
          color="text-gray-medium"
        />
      </template>
    </AppInput>
    <button @click="closeSearchBox">
      <AppIcon
        name="close"
        color="text-gray-medium hover:text-blue-primary"
        class="mr-14"
        size="md"
      />
    </button>
    <div
      v-if="isListOpen"
      class="absolute inset-x-0 top-full bg-white rounded-b z-1 shadow-lg max-h-[400px] overflow-auto"
    >
      <SearchBoxList
        :query="search"
        :courses="courses"
        :teachers="teachers"
        :loading="isLoading"
        @closeList="closeSearchBox"
      />
    </div>
  </div>
</template>

<script>
import search from '@mixins/search'
import SearchBoxList from '@library/element/dropdown/dropdown-search/search-box'
export default {
  name: 'SearchBoxMobileHeader',
  components: {
    SearchBoxList
  },
  mixins: [search],
  methods: {
    closeSearchBox () {
      this.$emit('emitCloseSearchBox')
    }
  }
}
</script>
